import { render, staticRenderFns } from "./BusyTimeIndicatorThresholdTableButton.vue?vue&type=template&id=3968ab83&"
import script from "./BusyTimeIndicatorThresholdTableButton.vue?vue&type=script&lang=js&"
export * from "./BusyTimeIndicatorThresholdTableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports